/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import PropTypes from 'prop-types';

import './ImageButton.css';

const ImageButton = ({ children, onClick, style }) => (
  <button className="cmp-imagebutton" onClick={onClick} style={style}>
    {children}
  </button>
);
ImageButton.propTypes = {
  size: PropTypes.number,
  fontSize: PropTypes.number,
  text: PropTypes.string,
  style: PropTypes.object,
};
ImageButton.defaultProps = {
  size: 34,
  fontSize: 14,
  strokeWidth: 1,
};

export default ImageButton;